module.exports = __webpack_public_path__ + "static/img/esp32-1.1114d45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/esp32-1.svg
// module id = R99r
// module chunks = 0